// extracted by mini-css-extract-plugin
export default {"container":"style_container__p2c52","page":"style_page__EPPm5","error":"style_error__6wU1i"};